import { Schema } from 'effect';
import { Location2DSchema } from './location';

export const ControlZoneSchema = Schema.Struct({
  points: Schema.Array(Location2DSchema)
});
export type ControlZone = Schema.Schema.Type<typeof ControlZoneSchema>;

export const FlightNetworkSchema = Schema.transform(
  Schema.Struct({
    center_control_zone: Schema.encodedSchema(ControlZoneSchema)
  }),
  Schema.Struct({
    centerControlZone: ControlZoneSchema
  }),
  {
    strict: true,
    decode: (api) => ({
      centerControlZone: api.center_control_zone
    }),
    encode: (client) => ({
      center_control_zone: client.centerControlZone
    })
  }
);
export type FlightNetwork = Schema.Schema.Type<typeof FlightNetworkSchema>;
